// extracted by mini-css-extract-plugin
module.exports = {"container":"hooray-card_container__2QTKt","cardTitle":"hooray-card_cardTitle__MPBdQ","cardDescription":"hooray-card_cardDescription__S5U7f","wrapper":"hooray-card_wrapper__3XM8Y"};